import React from 'react';
import { RequireAuthWrapper } from 'components';
import { Footer } from './Footer';
import { Navbar } from './Navbar';

export const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='bg-light d-flex flex-column flex-fill wrapper'>
      <Navbar />
      <main className='d-flex flex-column flex-grow-1'>
        <RequireAuthWrapper>{children}</RequireAuthWrapper>
      </main>
      <Footer />
    </div>
  );
};
